import { Typography, Space, theme } from 'antd';
import type { CSSProperties, ReactNode } from 'react';

const { Title } = Typography;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  showDivider?: boolean;
  subtitleStyle?: CSSProperties;
  /** Hook for a page that needs its own header layout (e.g. stacked actions). */
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumb,
  showDivider = true,
  subtitleStyle,
  className,
}: PageHeaderProps) {
  const { token } = theme.useToken();
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 24,
        marginBottom: 28,
        paddingBottom: 20,
        borderBottom: showDivider ? `1px solid ${token.colorBorderSecondary}` : 'none',
        flexWrap: 'wrap',
      }}
    >
      <div className="page-header__main" style={{ minWidth: 0, flex: '1 1 240px' }}>
        {breadcrumb && <div style={{ marginBottom: 10 }}>{breadcrumb}</div>}
        <Title
          level={3}
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: '-0.015em',
            lineHeight: 1.2,
          }}
        >
          {title}
        </Title>
        {subtitle && (
          <Typography.Text
            type="secondary"
            style={{ fontSize: 13, marginTop: 6, display: 'inline-block', ...subtitleStyle }}
          >
            {subtitle}
          </Typography.Text>
        )}
      </div>
      {actions && (
        <Space size={8} wrap>
          {actions}
        </Space>
      )}
    </div>
  );
}
